import "./courses.8a1ac275.js";


      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiree135"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiree135"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $ayMG0 = parcelRequire("ayMG0");

var $aRPiL = parcelRequire("aRPiL");

var $acw62 = parcelRequire("acw62");

var $ayMG0 = parcelRequire("ayMG0");


var $ayMG0 = parcelRequire("ayMG0");

function $f0a6747413e9447e$export$2e2bcd8739ae039({ children: children }) {
    document.addEventListener("DOMContentLoaded", function() {
        const carousel = document.querySelector(".carousel");
        const wrapper = document.querySelector(".wrapper");
        const firstCard = carousel.querySelector(".card");
        const firstCardWidth = firstCard.offsetWidth;
        let isDragging = false, startX, startScrollLeft;
        const dragStart = (e)=>{
            isDragging = true;
            carousel.classList.add("dragging");
            startX = e.pageX;
            startScrollLeft = carousel.scrollLeft;
        };
        const dragging = (e)=>{
            if (!isDragging) return;
            // Calculate the new scroll position
            const newScrollLeft = startScrollLeft - (e.pageX - startX);
            // Check if the new scroll position exceeds
            // the carousel boundaries
            if (newScrollLeft <= 0 || newScrollLeft >= carousel.scrollWidth - carousel.offsetWidth) {
                // If so, prevent further dragging
                isDragging = false;
                return;
            }
            // Otherwise, update the scroll position of the carousel
            carousel.scrollLeft = newScrollLeft;
        };
        const dragStop = ()=>{
            isDragging = false;
            carousel.classList.remove("dragging");
        };
        carousel.addEventListener("mousedown", dragStart);
        carousel.addEventListener("mousemove", dragging);
        document.addEventListener("mouseup", dragStop);
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "carouseldiv",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "wrapper",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                className: "carousel",
                children: children
            })
        })
    });
}
function $f0a6747413e9447e$export$60332b2344f7fe41({ header: header, roles: roles, description: description, contribution: contribution, link: link }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
        className: "card",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                className: "sub-header",
                children: header
            }),
            "Roles: ",
            roles,
            /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                className: "cardlist",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                        children: description
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                        children: contribution
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                className: "link",
                href: link,
                children: "Check it out!"
            })
        ]
    });
}
function $f0a6747413e9447e$export$d2804e1909720cef() {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
        className: "endcard"
    });
}



var $ayMG0 = parcelRequire("ayMG0");


var $ayMG0 = parcelRequire("ayMG0");

function $da2991f09c9c2412$export$2e2bcd8739ae039({ children: children, text: text }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "tooltip",
        children: [
            children,
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: "tooltiptext",
                children: text
            })
        ]
    });
}


function $8ef988b2cc978acd$export$2e2bcd8739ae039({ name: name, tooltip: tooltip = false }) {
    const icon = /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "icon-div",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
            src: `icons/${name}.svg`
        })
    });
    if (tooltip) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $da2991f09c9c2412$export$2e2bcd8739ae039), {
        text: name.split("-")[0],
        children: icon
    });
    return icon;
}



function $739818a2655d6a07$export$86fbec116b87613f() {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "content",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                children: "Hello!"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                src: "headshot.png",
                className: "headshot"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                children: "Welcome to my site! I'm currently doing some renovating so a few things may not work as expected, I apologize!"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                className: "header",
                children: "Skills"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8ef988b2cc978acd$export$2e2bcd8739ae039), {
                name: "Python-Light",
                tooltip: true
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8ef988b2cc978acd$export$2e2bcd8739ae039), {
                name: "C",
                tooltip: true
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8ef988b2cc978acd$export$2e2bcd8739ae039), {
                name: "CS",
                tooltip: true
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8ef988b2cc978acd$export$2e2bcd8739ae039), {
                name: "Java-Light",
                tooltip: true
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8ef988b2cc978acd$export$2e2bcd8739ae039), {
                name: "JavaScript",
                tooltip: true
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8ef988b2cc978acd$export$2e2bcd8739ae039), {
                name: "TypeScript",
                tooltip: true
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8ef988b2cc978acd$export$2e2bcd8739ae039), {
                name: "HTML",
                tooltip: true
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8ef988b2cc978acd$export$2e2bcd8739ae039), {
                name: "CSS",
                tooltip: true
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8ef988b2cc978acd$export$2e2bcd8739ae039), {
                name: "Bash-Light",
                tooltip: true
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8ef988b2cc978acd$export$2e2bcd8739ae039), {
                name: "Git",
                tooltip: true
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8ef988b2cc978acd$export$2e2bcd8739ae039), {
                name: "Github-Light",
                tooltip: true
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8ef988b2cc978acd$export$2e2bcd8739ae039), {
                name: "Docker",
                tooltip: true
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8ef988b2cc978acd$export$2e2bcd8739ae039), {
                name: "Kubernetes",
                tooltip: true
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8ef988b2cc978acd$export$2e2bcd8739ae039), {
                name: "DotNet",
                tooltip: true
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8ef988b2cc978acd$export$2e2bcd8739ae039), {
                name: "GraphQL-Dark",
                tooltip: true
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8ef988b2cc978acd$export$2e2bcd8739ae039), {
                name: "FastAPI",
                tooltip: true
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8ef988b2cc978acd$export$2e2bcd8739ae039), {
                name: "React-Light",
                tooltip: true
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8ef988b2cc978acd$export$2e2bcd8739ae039), {
                name: "NodeJS-Dark",
                tooltip: true
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8ef988b2cc978acd$export$2e2bcd8739ae039), {
                name: "Postman",
                tooltip: true
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8ef988b2cc978acd$export$2e2bcd8739ae039), {
                name: "Unity-Dark",
                tooltip: true
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8ef988b2cc978acd$export$2e2bcd8739ae039), {
                name: "VSCode-Light",
                tooltip: true
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $da2991f09c9c2412$export$2e2bcd8739ae039), {
                text: "Perforce (P4V)",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        src: "icons/Perforce.png",
                        className: "icon-div bg"
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8ef988b2cc978acd$export$2e2bcd8739ae039), {
                name: "PostgreSQL-Light",
                tooltip: true
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8ef988b2cc978acd$export$2e2bcd8739ae039), {
                name: "Figma-Dark",
                tooltip: true
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8ef988b2cc978acd$export$2e2bcd8739ae039), {
                name: "Rider-Dark",
                tooltip: true
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                children: "Recent Projects"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                children: [
                    "Take a peek at the rest of my projects ",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                        href: "./projects.html",
                        children: "here!"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $f0a6747413e9447e$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f0a6747413e9447e$export$d2804e1909720cef), {}),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f0a6747413e9447e$export$60332b2344f7fe41), {
                        header: "Kin Tandem - Senior Capstone",
                        roles: "Web Developer, Technical Writer, Backend Developer",
                        description: "Kin Tandem is a couch co-op adventure game about a brother and sister searching for answers in a hostile temple. Solve magical puzzles and combat the cultists within to uncover the mysteries behind the chained sun. Work as a team to solve puzzle with each character unique abilities. Manu can climb on Barsa's shoulders to reach new heights. Ascend a temple to follow your father\u2019s footsteps.",
                        contribution: "I am currently working on developing the project website, and I am also involved in the technical documentation: contributing to the GDD, SRS, and other design documents.",
                        link: "https://main.d2pys5em34ekq0.amplifyapp.com/"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f0a6747413e9447e$export$60332b2344f7fe41), {
                        header: "Grocery Price Comparer - Full Stack Web Application",
                        roles: "Frontend Developer",
                        description: "The problem: the cost of groceries has increased, so shoppers result to going to different stores for the best deals. With so many options, it may be hard to remember which stores have the cheapest products. Limiting shopping to one store leads to overspending, but keeping trace of prices across multiple stores is taxing and time consuming. Solution: We are making an app that will guide users into buying items on their grocery lists for the cheapest prices. The user submits one grocery list and selects their preferred stores, and the app will make itemized lists for what items to buy at each store based on prices. This ensures that users are always getting the best deals.",
                        contribution: "I worked on the front end of the application, implementing the user interface and handling user interactions."
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f0a6747413e9447e$export$60332b2344f7fe41), {
                        header: "Blueboard - Full Stack Web Application",
                        roles: "Backend Developer",
                        description: "Blueboard is an online quiz distribution platform that serves both students and professors. Different functions are available depending on the type of account. Professors can create courses, create and edit quizzes for each course, create announcements for courses, and grade student quiz submissions. Certain quiz questions can be set to be autograded. Studets can enroll in courses using the provided registration code, view professor annoucements and created quizzes along with their deadlines, take the quizzes and see all of their grades.",
                        contribution: "I worked on the backend of the site, managing the server queries to the database and handling the deployment of our site. I used PostgreSQL to query the database to insert and retrieve account information, faciliate account enrollment into courses, and store and retrieve quiz objects. The site is deployed using Fly.io's services.",
                        link: "https://cs375blueboard.fly.dev"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f0a6747413e9447e$export$60332b2344f7fe41), {
                        header: "Fool's Gambit - MVP Project",
                        roles: "Backend Developer, Artist",
                        description: "Our team was tasked with creating an MVP utilizing the Agile Development Method. We used a Kanban board to keep track of our tasks, participated in weekly stand-up meetings, and presented our progress at Sprint Reviews at the end of each three week sprint. We decided to make a chess inspired tower defense game, where the chess pieces are the towers, and move according to standard chess piece movement. This game is inspired by Bloons Tower Defense, but key differences are that pieces can be repositioned after landing a certain amount of hits, and the track enemies travel on will change every 8 levels.",
                        contribution: "I was responsible for level design, manually coding all 50 levels, as well as coding all enemy variations and enemy buff effects. I also hand drew all of the sprites for the pieces (including tower upgrade sprites and enemy buff sprites).",
                        link: "https://drive.google.com/file/d/1ku73KWGRa8QZSKKoMTmLMivfbljlPj9e/view"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f0a6747413e9447e$export$d2804e1909720cef), {})
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                className: "header",
                children: "Interests"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "text",
                children: "I enjoy playing video games; I am a big fan of RPGs such as Final Fantasy XVI, Octopath Traveler, and Pokemon. I also like to read fantasy, crochet (mostly amigurumi), and knit. "
            })
        ]
    });
}



var $8xK8u = parcelRequire("8xK8u");
let $70fc9a727fa662ae$var$container = document.getElementById("app");
let $70fc9a727fa662ae$var$root = (0, $aRPiL.createRoot)($70fc9a727fa662ae$var$container);
$70fc9a727fa662ae$var$root.render(/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $acw62.StrictMode), {
    children: [
        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8xK8u.Navbar), {}),
        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $739818a2655d6a07$export$86fbec116b87613f), {})
    ]
}));


//# sourceMappingURL=mackenzie-ligon.github.io.ebe2d577.js.map
